export default __webpack_public_path__ + "static/media/gallery_01.69d65a97.jpg";